module.exports = __webpack_public_path__ + "static/media/icons-spritesheet2.589d050d.png";